export const mutations = {
  setNewsDetails (state, { key, data }) {
    state.cache = Object.assign({}, state.cache, { [key]: data })
  },
  setPopularList (state, popularList) {
    state.popularList = popularList
    state.popularLoaded = true
  }
}
